import React from 'react'
import styles from './filterFooter.module.css';
import { Button } from '@mui/material';

interface FilterFooterProps {
    onCancelClick: () => void;
    onApplyClick: () => void;
}

export const FilterFooter = (props: FilterFooterProps) => {
    const { onCancelClick, onApplyClick } = props;
    return (
        <div className={styles.footerContainer}>
            <Button className={styles.clearAllButton} onClick={onCancelClick}>
                <p>
                    Cancel
                </p>
            </Button>
            <Button className={styles.closeButton} onClick={onApplyClick}>
                Apply
            </Button>
        </div>
    )
}
